import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAmount'
})

export class AmountFormatterPipe implements PipeTransform {
  transform(value: number, separator: string = ' '): string {
    if (!value) {
      return;
    }
    let pr = value.toString().split('.');

    let array = pr[0].split('');
    let counter = 0;

    let firstPart = '';
    for (let i = pr[0].length - 1; i >= 0; i--) {
      if (counter === 3) {
        firstPart += separator + array[i];
        counter = 0;
      } else {
        firstPart += array[i];
      }
      counter++;

    }

    let rest = '';
    if (pr.length > 1) {
      rest += '.';
      rest += pr[1].length === 1 ? pr[1] + '0' : pr[1];
    }

    return firstPart.split('').reverse().join('') + rest;
  }
}
